/** Match TanStack-style route patterns (e.g. `/users/$userId/edit`). */
export function matchRoutePattern(pathname: string, pattern: string): boolean {
  const normalizedPath = pathname.replace(/\/+$/, "") || "/";
  const normalizedPattern = pattern.replace(/\/+$/, "") || "/";

  if (normalizedPattern === "/") {
    return normalizedPath === "/";
  }

  const pathSegments = normalizedPath.split("/").filter(Boolean);
  const patternSegments = normalizedPattern.split("/").filter(Boolean);

  if (pathSegments.length < patternSegments.length) {
    return false;
  }

  for (let i = 0; i < patternSegments.length; i++) {
    const patternSegment = patternSegments[i]!;
    const pathSegment = pathSegments[i];
    if (patternSegment.startsWith("$")) {
      continue;
    }
    if (patternSegment !== pathSegment) {
      return false;
    }
  }

  return true;
}

export function isViewActive(pathname: string, patterns: string[]): boolean {
  return patterns.some((pattern) => matchRoutePattern(pathname, pattern));
}

export function findModuleSlugForPathname(
  navigation: { modules: Array<{ slug: string; views: NavigationViewLike[] }> },
  pathname: string,
): string | null {
  for (const mod of navigation.modules) {
    for (const view of mod.views) {
      const patterns =
        view.routePatterns.length > 0
          ? view.routePatterns
          : view.defaultPath
            ? [view.defaultPath]
            : [];
      if (isViewActive(pathname, patterns)) {
        return mod.slug;
      }
    }
  }
  return null;
}

type NavigationViewLike = {
  defaultPath: string;
  routePatterns: string[];
};
